<script setup>
import { ref, watch } from "vue";

const props = defineProps(["column", "filterChangedCallback"]);
const model = ref({ from: "", to: "" });

watch(model, () => {
  props.column.setFilterModel({
    type: "inRange",
    dateFrom: model.value.from || null,
    dateTo: model.value.to || null
  });

  props.filterChangedCallback();
}, { deep: true });
</script>

<template>
  <div class="date-filter">
    <label>From:</label>
    <input type="datetime-local" v-model="model.from" />

    <label>Until:</label>
    <input type="datetime-local" v-model="model.to" />
  </div>
</template>

<style scoped>
.date-filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
}

input {
  font-size: 12px;
  padding: 4px;
}
</style>
